export interface VisitDocumentInterface {
  id: string;
  clientVisitId: string;
  documentTemplateId: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  clientVisit?: {
    id: string;
    visitDate: string;
  };
  documentTemplate?: {
    id: string;
    name: string;
  };
  documentTemplateSolution?: {
    id: string;
    documentTemplateId: string;
    snapshot: any;
  };
  documentTemplateSolutionAttributes?: {
    documentTemplateId: string;
    snapshot: any;
  };
}

export class VisitDocument implements VisitDocumentInterface {
  id: string;
  clientVisitId: string;
  documentTemplateId: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  clientVisit?: {
    id: string;
    visitDate: string;
  };
  documentTemplate?: {
    id: string;
    name: string;
  };
  documentTemplateSolution?: {
    id: string;
    documentTemplateId: string;
    snapshot: any;
  };
  documentTemplateSolutionAttributes?: {
    documentTemplateId: string;
    snapshot: any;
  };

  constructor(data: Partial<VisitDocumentInterface>) {
    this.id = data.id!;
    this.clientVisitId = data.clientVisitId!;
    this.documentTemplateId = data.documentTemplateId!;
    this.status = data.status!;
    this.createdAt = data.createdAt!;
    this.updatedAt = data.updatedAt!;
    this.clientVisit = data.clientVisit;
    this.documentTemplate = data.documentTemplate;
    this.documentTemplateSolution = data.documentTemplateSolution;
    this.documentTemplateSolutionAttributes = data.documentTemplateSolutionAttributes;
  }

  toJson(): VisitDocumentInterface {
    return {
      id: this.id,
      clientVisitId: this.clientVisitId,
      documentTemplateId: this.documentTemplateId,
      status: this.status,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      clientVisit: this.clientVisit,
      documentTemplate: this.documentTemplate,
      documentTemplateSolution: this.documentTemplateSolution,
      documentTemplateSolutionAttributes: this.documentTemplateSolutionAttributes,
    };
  }
}